import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createModal } from 'react-modal-promise';
import Input, { parseIntValue } from '../Input';

function TermModal({ offerTerm, termList, close }) {
  const [term, setTerm] = useState(offerTerm);
  const [error, setError] = useState('');

  return (
    <div className="p-modal-container">
      <div className="p-modal">
        <i
          onClick={() => close(false)}
          className="modal-close close icon"
          alt="close"
        />
        <div className="p-modal-body">
          <div>
            <div className="offer-list-term-box">
              <Input
                value={term}
                onChange={val => {
                  setTerm(parseIntValue(val));
                  setError('');
                }}
              />
              months
            </div>
            <div className="error">{error}</div>
          </div>
        </div>
        <div className="p-modal-actions">
          <button
            className="btn btn-primary btn-large btn-large-default"
            onClick={() => {
              if (termList?.includes(term)) {
                setError('The specified term already exists.');
              } else if (term <= 0) {
                setError('Invalid term.');
              } else {
                close(term);
              }
            }}
          >
            Confirm
          </button>
          <button
            className="btn btn-default btn-large"
            onClick={() => close(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

TermModal.propTypes = {
  offerTerm: PropTypes.number,
  termList: PropTypes.array,
  close: PropTypes.func,
};

export default createModal(TermModal);
